import * as STANDARD_MODULE_FIELDS from "@lennd/value-types/src/constants/standard-module-field-ids";

export const NAMESPACE = "AddActivityRow";
export const preserveFields = [
  STANDARD_MODULE_FIELDS.SCHEDULES.STARTS_AT,
  STANDARD_MODULE_FIELDS.SCHEDULES.ENDS_AT
];
